import { ChangeDetectionStrategy, Component, Input, OnInit, inject, signal } from '@angular/core';
import { AssetDto, GalleryDto, GalleryPublicAccessLevel } from '@picflow/types';
import { firstValueFrom } from 'rxjs';
import { GalleryAccessLevel } from '../../../lib/access-level';
import { PICFLOW_ANALYTICS } from '../../../picflow-analytics';
import { AccessLevelService } from '../../../services/access-level.service';
import { DialogService } from '../../../services/dialog.service';
import { GalleryService } from '../../../services/gallery.service';
import { StateService } from '../../../services/state.service';
import { ToastService } from '../../../services/toast.service';
import { CopyClipboardDirective } from '../../../shared-extra/directives/copy-to-clipboard';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { ShareGalleryDialogComponent } from '../../dialogs/share-gallery-dialog/share-gallery-dialog.component';
import { EditableGalleryUrlFieldComponent } from '../editable-gallery-url-field/editable-gallery-url-field.component';
import { ShareGallerySocialLinksComponent } from '../share-gallery-social-links/share-gallery-social-links.component';

@Component({
  selector: 'app-share-asset-link',
  templateUrl: './share-asset-link.component.html',
  styleUrls: ['./share-asset-link.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    EditableGalleryUrlFieldComponent,
    SvgComponent,
    ButtonDirective,
    CopyClipboardDirective,
    ShareGallerySocialLinksComponent,
  ],
})
export class ShareAssetLinkComponent implements OnInit {
  public state = inject(StateService);
  private accessLevelService = inject(AccessLevelService);
  private toasts = inject(ToastService);
  private galleryService = inject(GalleryService);
  private dialog = inject(DialogService);
  @Input() gallery: GalleryDto;
  @Input() asset: AssetDto;
  accessLevel = signal<GalleryAccessLevel>(undefined);
  isEditingPath = signal(false);
  publicAccessLevel = signal<GalleryPublicAccessLevel>(undefined);
  loading = signal(true);
  private analytics = inject(PICFLOW_ANALYTICS);

  async ngOnInit() {
    const [accessLevel, accessLevels] = await Promise.all([
      this.accessLevelService.getAccessLevel(this.gallery),
      this.accessLevelService.getAccessLevels(this.gallery),
    ]);
    this.accessLevel.set(accessLevel);
    this.publicAccessLevel.set(accessLevels[1]);
    this.loading.set(false);
  }

  onPasswordCopied() {
    this.toasts.add('Password Copied', 'success');
    this.analytics.track('gallery_password_copied');
  }

  async openMainGallerySharing() {
    if (this.gallery.section) {
      const parentGallery = await firstValueFrom(this.galleryService.getGallery(this.gallery.parent_gallery_id));
      this.dialog.open(ShareGalleryDialogComponent, { gallery: parentGallery, mode: 'link' });
    } else {
      this.dialog.open(ShareGalleryDialogComponent, { gallery: this.gallery, mode: 'link' });
    }
  }
}
